<template>
  <el-header id="myHeader" height="80px">
    <el-col :span="6" class="left">
      <router-link to="/">Noosphere自动驾驶平台</router-link>
    </el-col>
    <el-col :span="17" :offset="1">
      <el-menu
        mode="horizontal"
        text-color="#ffffff"
        active-text-color="#0d66ee"
        :default-active="activeIndex"
        :router="true"
        class="el-menu-demo"
      >
        <el-menu-item index="首页" :route="{ path: '/' }">首页</el-menu-item>
        <el-menu-item index="开发套件" :route="{ path: '/developer' }"
          >开发套件</el-menu-item
        >
        <el-menu-item index="实验室解决方案" :route="{ path: '/laboratory' }"
          >实验室解决方案</el-menu-item
        >
        <el-submenu index="产教融合合作案例" popper-class="submenubox">
          <template slot="title">产教融合合作案例</template>
          <el-menu-item index="北航软件学院案例" :route="{ path: '/software' }"
            >北航软件学院案例</el-menu-item
          >
          <el-menu-item
            index="北航交通科学与工程学院案例"
            :route="{ path: '/traffic' }"
            >北航交通科学与工程学院案例</el-menu-item
          >
          <el-menu-item index="北京联合大学案例" :route="{ path: '/union' }"
            >北京联合大学案例</el-menu-item
          >
        </el-submenu>
        <el-submenu index="开放平台" popper-class="submenubox">
          <template slot="title">开放平台</template>
          <el-menu-item index="仿真平台" :route="{ path: '/emulation' }"
            >仿真平台</el-menu-item
          >
          <el-menu-item index="课程平台" :route="{ path: '/course' }"
            >课程平台</el-menu-item
          >
        </el-submenu>
        <el-menu-item index="热点活动" :route="{ path: '/news' }"
          >热点活动</el-menu-item
        >
        <el-menu-item index="产业生态" :route="{ path: '/IndustrialEcology' }"
          >产业生态</el-menu-item
        >
      </el-menu>
    </el-col>
  </el-header>
</template>

<script>
export default {
  name: "myHeader",
  props: ["activeIndex"]
};
</script>

<style lang="less">
@font-face {
  font-family: "庞门正道";
  src: url("../assets/font/PANGMENZHENGDAO.TTF");
}
#myHeader {
  padding: 0;
  color: #fff;
  background: #000;
  > div {
    height: 80px;
    line-height: 80px;
  }
  .left {
    text-align: right;
    font-size: 26px;
    font-family: "庞门正道";
  }
  .el-menu-demo {
    border-bottom: none;
    height: 80px;
    background: #000;
    .el-menu-item {
      height: 80px;
      line-height: 80px;
      &:hover {
        background: #2f2f2f;
      }
    }
    .el-submenu .el-submenu__title {
      height: 80px;
      line-height: 80px;
      &:hover {
        background: #2f2f2f;
      }
    }
  }
}
.submenubox {
  .el-menu {
    margin-top: 0;
    background: #2f2f2f;
    .el-menu-item {
      background: #2f2f2f;
    }
  }
}
</style>
